export const CREDIT_OPTIONS = [500, 1000, 1500, 2000, 3000, 5000, 8000, 10000]
